import { aomGraphqlRequest } from 'core/utils/backend-service';
import { DeviceTypeDetails } from 'modules/devices/domain/api/device-type.api';
import { mapDeviceTypeDetailsFromModelToApi } from 'modules/devices/domain/mappers';
import { modifyDeviceTypeMutation } from './device-types.queries';

export const updateDeviceTypeAOM = (deviceType: DeviceTypeDetails): Promise<{ result: string }> =>
    aomGraphqlRequest(modifyDeviceTypeMutation(), { input: mapDeviceTypeDetailsFromModelToApi(deviceType) }).then(
        () => ({ result: 'ok' })
    );
